import React from 'react';
import { MemoryMonitor } from '../components/ui/MemoryMonitor';
import LanguageTest from '../components/LanguageTest';

const MonitorPage: React.FC = () => {
  return (
    <div style={{
      padding: '20px',
      minHeight: '100vh',
      background: '#f5f5f5',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ 
        textAlign: 'center', 
        color: '#333', 
        marginBottom: '30px',
        fontSize: '2.5rem'
      }}>
        🛠️ Development Monitor
      </h1>
      
      <div 
        className="monitor-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px',
          maxWidth: '1400px',
          margin: '0 auto'
        }}
      >
        {/* Memory Monitor Section */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '2px solid #e0e0e0'
        }}>
          <h2 style={{ 
            color: '#2196F3', 
            marginBottom: '15px',
            fontSize: '1.5rem',
            borderBottom: '2px solid #2196F3',
            paddingBottom: '8px'
          }}>
            🧠 Memory Monitor
          </h2>
          <MemoryMonitor isStandalone={true} />
        </div>

        {/* Language Test Section */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '2px solid #e0e0e0'
        }}>
          <h2 style={{ 
            color: '#4CAF50', 
            marginBottom: '15px',
            fontSize: '1.5rem',
            borderBottom: '2px solid #4CAF50',
            paddingBottom: '8px'
          }}>
            🌐 Language Test
          </h2>
          <LanguageTest />
        </div>
      </div>

      {/* Responsive design for mobile */}
      <style>{`
        @media (max-width: 768px) {
          .monitor-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default MonitorPage; 